module.exports = __webpack_public_path__ + "img/gold-egg-default.c9ff26d8.png";